import { getRuntimeValue } from './config/runtime';
//
// const VUE_APP_WS_URL = getRuntimeValue('VUE_APP_WS_URL') || process.env.VUE_APP_WS_URL || 'ws://api.rblnhoopdhot.com/websocket';
// const VUE_APP_BASEURL = getRuntimeValue('VUE_APP_BASEURL') || process.env.VUE_APP_BASEURL || 'https://api.rblnhoopdhot.com';
// const SERVICE_URL = getRuntimeValue('VUE_APP_SERVICE_URL') || process.env.VUE_APP_SERVICE_URL || 'https://google.com';
const VUE_APP_WS_URL = 'ws://bapig.jiekouduogongnengpan.com/websocket';
const VUE_APP_BASEURL = 'https://bapig.jiekouduogongnengpan.com';
// const VUE_APP_BASEURL = 'http://localhost:8080';
const SERVICE_URL = 'https://zliko.coqbjjguytdys.in//index?key=c966b710feadaccaca08db7d31c299ef&lang=en';

export { VUE_APP_WS_URL, VUE_APP_BASEURL, SERVICE_URL };
